import {isExpectedError} from '@/src/shared/utils/expected-error'
import {injectable} from 'inversify'
import type {IErrorReporter} from '@/src/ports/services/monitoring'
import * as Sentry from '@sentry/nextjs'

@injectable()
export class SentryErrorReporter implements IErrorReporter {
  capture(error: Error | string, context?: Record<string, any>): void {
    if (isExpectedError(error)) return
    if (context) {
      Sentry.setContext('additional', context)
    }

    Sentry.captureException(error instanceof Error ? error : new Error(String(error)))
  }
}
